import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ModalService } from '@services/remote/modal.service';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalComponent {

  // modalService used in html template
  constructor(public modalService: ModalService) { }
}